<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { useMate } from "@/stores/mate";

const props = defineProps<{
  name: string;
}>();
const emit = defineEmits<{
  (e: "update:name", value: string): void;
  (e: "onAvatarClick"): void;
}>();
const { t } = useI18n();

const mateStore = useMate();
</script>
<template>
  <div class="flex flex-col gap-10 items-center justify-center">
    <div class="text-white text-[2rem] font-bold text-center">
      {{ $t("loginmodal.characterName") }}
    </div>
    <div class="flex flex-col gap-2 items-center">
      <div
        class="rounded overflow-hidden shadow-lg aspect-[3/4] w-32 md:w-64 items-center justify-center"
        @click="emit('onAvatarClick')"
      >
        <VanImage
          :src="`${mateStore.currentMate!.mediaUrl}?x-oss-process=image/resize,w_300/format,webp`"
          class="w-full aspect-[3/4] pointer-events-none"
          fit="object-contain"
          crossorigin="anonymous"
        >
          <template v-slot:loading>
            <span class="loading loading-sm loading-ring" />
          </template>
        </VanImage>
      </div>
      <div class="flex gap-2 bg-neutral rounded">
        <input
          :placeholder="$t('loginmodal.enterName')"
          :value="props.name"
          class="input input-ghost focus:outline-0 focus:bg-transparent flex-1"
          type="text"
          @input="emit('update:name', $event.target?.value)"
        />
        <div class="flex items-center justify-center p-2">
          <gender-badge :gender="mateStore.currentMate?.gender" class="w-4" />
        </div>
      </div>
    </div>
  </div>
</template>
